/**
 * wangEditor文本编辑器使用
 * @link https://www.wangeditor.com/
 * @description Web 富文本编辑器
 */

import EdWangEditor from './src/EdWangEditor.vue'

/* istanbul ignore next */
EdWangEditor.install = function (Vue) {
  Vue.component(EdWangEditor.name, EdWangEditor)
}

export default EdWangEditor
